<template>
  <BasicTemplate>
    <h3>
      <router-link to="/game-rollouts">Progressive Rollouts</router-link>
      /
      Progressive Rollout new
    </h3>
    <RolloutForm is-new @cancel="goBack" @saved="onSaved" />
  </BasicTemplate>
</template>

<script>
import BasicTemplate from '../../../templates/basic.vue';
import RolloutForm from './form.vue';

export default {
  name: 'GameRolloutNew',
  components: { BasicTemplate, RolloutForm },
  methods: {
    goBack() {
      this.$router.push('/game-rollouts');
    },
    onSaved(id) {
      if (id) {
        this.$router.push(`/game-rollouts/${id}`);
        return;
      }
      this.goBack();
    },
  },
};
</script>
